var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('PackagingTypesCreateAdmin',{attrs:{"PT":_vm.PT},on:{"save":function($event){return _vm.save({edit: false})}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }